"use strict";

export default sb => {
    let executed = false;

    const sendForm = function sendForm() {
        jQuery('.table-filter form :input:not(.defer-submit)').on('option_change change', function(){
            jQuery('#button_submit').click();
        });
    };

    return {
        init() {
            sendForm();
            jQuery(document).ajaxStop(() => {
                if (!executed) {
                    executed = true;
                    jQuery('.table-filter form #button_submit').click();
                }
            });

        },
        destroy() {
            executed = null;
        }
    }
}
